import { useQuery } from 'react-query';
import { network } from 'services/network';

const getCriticalPathAddedTableData = (params) => {
    const payload = {
        compareVersionId: params.compareVersionId,
        contractId: params.contractId,
        latestVersionId: params.latestVersionId,
        projectId: params.projectId,
        filter: params.filterData,
    };
    return network
        .post('api/bo/getTopCriticalPathAdded', payload)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

export const useQueryCriticalPathAddedTableData = (params) => {
    return useQuery(['criticalPathAddedTableData', params], () => getCriticalPathAddedTableData(params), {
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
